import { useState } from 'react';
import { BlockKey, EvaluationSuccessAndFailureProps } from './types';
import DetailBlock from '../detail-block/detail-block';

export default function EvaluationSuccessAndFailure({
  statement,
  success,
  failure,
}: EvaluationSuccessAndFailureProps) {
  const [openStates, setOpenStates] = useState({
    criteria: false,
    success: false,
    failure: true,
  });

  const detailBlocksData = [
    {
      key: 'criteria' as BlockKey,
      title: 'Evaluation criteria',
      content: statement,
      emptyText: 'No criteria text.',
    },
    {
      key: 'success' as BlockKey,
      title: 'What the agent did well',
      content: success,
      emptyText: "The evaluator didn't note anything here.",
    },
    {
      key: 'failure' as BlockKey,
      title: 'What could be improved',
      content: failure,
      emptyText: 'Nothing to improve was noted for this criterion.',
    },
  ];

  const areAllOpen = Object.values(openStates).every(Boolean);

  const toggleAll = () => {
    const shouldExpand = !areAllOpen;
    setOpenStates({
      criteria: shouldExpand,
      success: shouldExpand,
      failure: shouldExpand,
    });
  };

  const handleToggle = (key: keyof typeof openStates) => {
    setOpenStates((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div className="flex flex-col gap-3">
      <button
        onClick={toggleAll}
        className="self-start text-xs font-medium text-prompt-safecomvulcan transition-colors hover:underline focus:underline focus:outline-none"
      >
        {areAllOpen ? 'Collapse all' : 'Expand all'}
      </button>

      {detailBlocksData.map((block) => (
        <DetailBlock
          key={block.key}
          title={block.title}
          content={block.content}
          emptyText={block.emptyText}
          isOpen={openStates[block.key]}
          onToggle={() => handleToggle(block.key)}
          onboardingKey={`evaluation-${block.key}`}
        />
      ))}
    </div>
  );
}
